<ng-template #content_gallery_config let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.gallery">
        <div class="side_popup_header">
            <span>{{localService.languageContent.gallery.popup_title}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" [ngStyle]="{'max-height' : localService.sideBarBodyHeight + 'px'}">
            <div *ngIf="idToDelete || parentIdToDelete" class="box">
                <app-message-box [message]="localService.languageContent.gallery.del_imgs" [IsConfirmationType]="true"
                    (onClose)="onCloseMessageBox($event)"></app-message-box>
            </div>
            <div *ngIf="!idToDelete && !parentIdToDelete">
                <div class="row" *ngIf="items && items.length > 0">
                    <div class="col-5">
                        <div style="margin-top: 7px;">
                            <label>{{localService.languageContent.gallery.cnt}}</label>
                            <span class="en">&nbsp;:&nbsp;{{items.length}}</span>
                        </div>
                    </div>
                    <div class="col-7">
                        <label>{{localService.languageContent.gallery.size}}</label>
                        <label class="en">&nbsp;(in MB)</label>
                        <span class="en">&nbsp;:&nbsp;{{ items | sum: 'v4' | number: '1.2-2'
                            }}&nbsp;</span>
                        <button class="button_icon danger icon_adjust" (click)="onAction(4)">delete_sweep</button>
                    </div>
                </div>
                <div class="add-gallery" *ngIf="!items || (items && items.length < maxItemsLimit)">
                    <app-file-upload *ngIf="isOpenPopup" (onFileUploaded)="onLoad()" [forId]="parentId"
                        [forId2]="businessId" [isBigSizeIcon]="true" [fileUploadFor]="FileUploadFor.Gallery"
                        [type]="galleryType"></app-file-upload>
                </div>
                <div class="box" *ngIf="items && items.length >= maxItemsLimit">
                    {{localService.languageContent.gallery.files_exceeded}}
                </div>
                <div *ngIf="items">
                    <div *ngIf="items.length > 0" class="banner" style="margin: 5px;">
                        <div class="row row_header-no-border freeze_height">
                            <div class="col-4">
                                {{localService.languageContent.gallery.on_off}}
                            </div>
                            <div class="col-6">
                                {{localService.languageContent.gallery.title}}
                            </div>
                        </div>
                        <div class="row row_header freeze_height">
                            <div class="col-4">
                                {{localService.languageContent.gallery.order}}
                            </div>
                            <div class="col-3">
                                {{localService.languageContent.gallery.format}}
                            </div>
                            <div class="col-5">
                                {{localService.languageContent.gallery.size}}&nbsp;(in MB)
                            </div>
                        </div>
                        <div *ngFor="let item of items;index as idx" class="styled_row freeze_col">
                            <div class="row">
                                <div class="col-2">
                                    <button class="button_icon icon_adjust"
                                        [ngStyle]="{'color': item.isSelected ? 'yellowgreen' : 'orangered' }"
                                        title="{{item.isSelected ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                                        (click)="onAction(1,item.key)">{{item.isSelected ? "toggle_on" :
                                        "toggle_off"}}</button>
                                    <button class="button_icon button_icon_color icon_adjust"
                                        (click)="onAction(8,item.v6)">link</button>
                                </div>
                                <div class="col-10">
                                    <input *ngIf="!item.isReadonly" id="{{elementIds.txtTitle+(idx+1)}}"
                                        [(ngModel)]="editItems[idx].v1" type="text" autocomplete="off"
                                        placeholder="{{localService.languageContent.gallery.title}}"
                                        title="{{localService.languageContent.gallery.title}}" />
                                    <span *ngIf="item.isReadonly">{{item.v1 != '' ? item.v1 : item.v2}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div [ngClass]="item.isReadonly ? 'col-4' : 'col-6'" class="en">
                                    <button class="button_icon button_icon_color icon_adjust"
                                        (click)="onAction(item.isReadonly ? 5 : 7,item.key)">{{item.isReadonly ?
                                        'remove_red_eye' : 'cancel'}}</button>
                                    <button class="button_icon button_icon_color icon_adjust"
                                        (click)="onAction(item.isReadonly ? 3 : 6,item.key)">{{item.isReadonly ? 'edit'
                                        : 'save'}}</button>
                                    <input *ngIf="!item.isReadonly" id="{{elementIds.txtOrder+(idx+1)}}"
                                        autocomplete="off" type="number" class="number cost gallery-order-nbr-edit"
                                        (keypress)="localService.isNumberOnly($event,numericConfig)"
                                        placeholder="{{localService.languageContent.gallery.order}}"
                                        title="{{localService.languageContent.gallery.order}}"
                                        [(ngModel)]="editItems[idx].v5" />
                                    <span *ngIf="item.isReadonly">{{item.v5 != '' ? item.v5 : '0'}}</span>
                                </div>
                                <div class="col-3 en gallery-file-format" *ngIf="item.isReadonly">
                                    {{item.v3}}
                                </div>
                                <div class="col-5 en gallery-file-size">
                                    {{item.v4}}
                                    <button class="button_icon danger icon_adjust"
                                        (click)="onAction(2, item.key)">delete_sweep</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>